import { render } from "./AuthenticationCard.vue?vue&type=template&id=4ae23510"
const script = {}
script.render = render

export default script